<template>
  <div>
    <router-view v-cloak/>
	<footer class="footer">
		<div class="container-fluid">
			<p class="text-muted mb-0">This character sheet uses trademarks and/or copyrights owned by Paizo Inc., which are used under Paizo's Community Use Policy. We are expressly prohibited from charging you to use or access this content. This character sheet is not published,
				endorsed, or specifically approved by Paizo Inc. For more information about Paizo's Community Use Policy, please visit <a href="http://paizo.com/communityuse">paizo.com/communityuse</a>. For more information about Paizo Inc. and Paizo
				products, please visit <a href="http://paizo.com">paizo.com</a>.
			</p>
		</div>
	</footer>
  </div>
</template>

<script>
export default {
	name: 'SystemSfrpg',
}
</script>

<style>
</style>
